import { useMutation } from "@tanstack/react-query";
import { login } from "../../../services/api";
import { useNavigate, useSearchParams } from "react-router-dom";

function FarmerCard({ data, phoneNumber, otp }) {
  const navigate = useNavigate();
  const profileImage = process.env.REACT_APP_ARVAN_S3_BASE_URL + data?.avatar;
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();
  const fullName = data?.firstName
    ? data?.firstName + " " + data?.lastName
    : "کشاورز مهمان";
  const farmerCode = data?.farmerCode;
  const farmerId = data?.id;
  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      localStorage.setItem("isExpert", true);
      localStorage.setItem("profile", JSON.stringify(data?.profile));
      localStorage.setItem("token", data?.token);
      if (searchParams.get("return-to")) {
        navigation(searchParams.get("return-to"));
      } else {
        navigate("/my-fields");
      }
    },
  });

  const loginHandler = () => {
    if (!phoneNumber) {
      if (searchParams.get("return-to")) {
        navigation(searchParams.get("return-to"));
      } else {
        navigate("/");
      }
    } else {
      loginMutation.mutate({
        phoneNumber: phoneNumber,
        otpCode: otp,
        farmerId: farmerId,
      });
    }
  };
  return (
    <div
      onClick={loginHandler}
      className="card-shadow cursor-pointer hover:translate-y-[-2px] duration-300 hover:brightness-105 !w-full flex gap-4 flex-row justify-between rounded-3xl p-2"
    >
      <div className="!w-[80px] !h-[80px] circle-neo">
        <img
          className="!rounded-full !w-[80px] !h-[80px]"
          alt="farmer_Image"
          src={profileImage}
        />
      </div>

      <div className="flex flex-col justify-center gap-5 w-[70%] items-start text-right">
        {data ? (
          <p className="text-sm text-[#404848] font-extrabold"> {fullName}</p>
        ) : null}

        {farmerCode && (
          <div className="flex flex-row justify-between w-full text-lg">
            <p className="text-sm max-lg:text-xs text-[#404848] font-extrabold">
              کدکشاورزی:
            </p>
            <p className="text-sm max-lg:text-xs text-[#404848] font-extrabold">
              {farmerCode}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default FarmerCard;
